const ja_JP = {
    info: {
        title: "Joiボタン",
        info: "お知らせ",
        null: "空",
        footerSubmit: "入れてほしい音声がありますか？投稿ページから送ってください。",
        toGithub: "ソースは GitHub にあります",
        notOfficial: "このサイトはファン作品であり、公式とは関係ありません。",
        overlapTips: "多重再生モードは手動で停止できません。再読み込みで停止して下さい。",
        loopTips: "選択したトラックをループします。他の2つの機能はループがオフになるまで無効になります。",
        clipInfo: "音声情報",
        clipSource: "配信タイトル",
        clipDate: "日付",
        clipDuration: "タイムスタンプ",
        clipOriginal: "元動画",
        clipSubmitter: "投稿者",
        clipJump: "この時点の元動画を開く",
        clipType: { label: "種類", video: "動画", stream: "配信切り抜き" },
        yt_channel: "@轴伊Joi_Channel",
        lang: "言語: "
    },
    action: {
        toggleNavbar: "ナビゲーションバーを切り替える",
        close: "閉じる",
        copy: "コピー",
        control: "コントロール",
        stopvoice: "再生停止",
        randomplay: "ランダム",
        overlap: "多重再生",
        autoplay: "連続再生",
        loop: "ループ再生",
        details: "詳細を表示",
        playing: "再生中：",
        noplay: "再生なし",
        volume: "ボリューム: "
    },
    lang: {
        'zh-CN': "简体中文",
        'en-US': "English",
        'ja-JP': "日本語"
    }
}
export default ja_JP;
